const FLAG = "paulistas-auto-reload";

const ASSET_ERR = /ChunkLoadError|Loading (CSS )?chunk|dynamically imported module|Importing a module script failed|error loading dynamically/i;

export const isAssetError = (err) => !!err && ASSET_ERR.test(`${err.name || ""} ${err.message || err}`);

// Reloads once per session window; returns false if a reload already happened recently.
export function reloadOnce() {
  try {
    if (sessionStorage.getItem(FLAG)) return false;
    sessionStorage.setItem(FLAG, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}

export function installAutoReload() {
  window.addEventListener(
    "error",
    (e) => {
      const t = e.target;
      const tag = t && t.tagName;
      if ((tag === "SCRIPT" || tag === "LINK") && /\/static\//.test(t.src || t.href || "")) reloadOnce();
      else if (isAssetError(e.error || e.message)) reloadOnce();
    },
    true
  );
  window.addEventListener("unhandledrejection", (e) => {
    if (isAssetError(e.reason)) reloadOnce();
  });
  // Clear the guard once the page has stayed healthy for a while.
  setTimeout(() => {
    try {
      sessionStorage.removeItem(FLAG);
    } catch {
      /* ignore */
    }
  }, 10000);
}
